const {
  OKTA_TESTING_DISABLEHTTPSCHECK = false,
  OKTA_CLIENT_ID,
  OKTA_ISSUER,
  OKTA_REDIRECT_URI,
} = window.MLBBest.envVariables || {};
export const REDIRECT_URI = OKTA_REDIRECT_URI + `/login/callback`;

export const OKTA_CONFIG = {
  oidc: {
    clientId: OKTA_CLIENT_ID,
    issuer: OKTA_ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ["openid", "profile", "email", "offline_access"],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
    tokenManager: {
      expireEarlySeconds: 60,
    },
  },
};
